import React, { useState } from "react";

import logo from "../assets/logo.png";
import { useAuth0 } from "../react-auth0-spa";
import { Button } from "reactstrap";

const Hero = () => {
  const { isAuthenticated, loginWithRedirect, getTokenSilently } = useAuth0();
  const [token, setToken] = useState();
  getTokenSilently().then(token => {
    setToken(token);
  });
  return (
    <div className="text-center hero my-5">
      <img className="mb-3 app-logo" src={logo} alt="Scope logo" width="120" />
      <h1 className="mb-4">Installation de SCOPE</h1>

      <p>
        {isAuthenticated
          ? "En fonction de votre téléphone, cliquez sur l'un des boutons ci-dessous pour installer SCOPE :"
          : "Depuis cette page, vous pourrez installer SCOPE sur votre téléphone une fois authentifié."}
      </p>
      {isAuthenticated ? (
        <>
          <div style={{ margin: "20px 0" }}>
            <a
              download
              mimetype="application/vnd.android.package-archive"
              href={`https://portefeuille.grouperandstad.fr/api/download/android?token=${token}`}
            >
              installer sur Android
            </a>
          </div>
          <div>
            <a
              href={`itms-services://?action=download-manifest&url=https://portefeuille.grouperandstad.fr/manifest.plist`}
            >
              installer sur iPhone
            </a>
          </div>
        </>
      ) : (
        <Button
          id="qsLoginBtn"
          color="primary"
          block
          onClick={() => loginWithRedirect({})}
        >
          se connecter
        </Button>
      )}
    </div>
  );
};

export default Hero;
